import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color, duration, size, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
const animationDuration = duration.animation.fast / 1000;
export const ContentContainer = styled(Box) `
  border: ${size.border.base.hairline} solid
    ${color.border.selectableBox.default};
  user-select: none;
  cursor: pointer;
  transition: background-color ${animationDuration}s ease;
  background: ${color.base.white};

  &.disabled {
    cursor: not-allowed;

    & > * {
      pointer-events: none;
    }
  }

  &.marked:not(.selected) {
    border-style: dashed;
  }

  &.marked:not(.disabled) {
    border-color: ${color.border.selectableBox.selected};
  }

  &.hover,
  &:hover {
    background-color: ${color.background.selectableBox.hovered};
  }

  &.disabled:not(.selected) {
    background-color: ${color.background.selectableBox.disabled};
  }

  &.selected:not(.disabled) {
    border-color: ${color.border.selectableBox.selected};
    background-color: ${color.background.selectableBox.selected};
  }

  &.disabled.selected {
    background-color: ${color.background.selectableBox.selectedDisabled};
  }

  ${focusVisible}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdGFibGVCb3gvc3R5bGVkL0NvbnRlbnRDb250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUM5RSxPQUFPLEVBQ0wsS0FBSyxFQUNMLFFBQVEsRUFDUixJQUFJLEdBQ0wsTUFBTSxnREFBZ0QsQ0FBQztBQUN4RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRWhDLE1BQU0saUJBQWlCLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO0FBRXpELE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtZQUMvQixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRO01BQy9CLEtBQUssQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLE9BQU87OztpQ0FHUCxpQkFBaUI7Z0JBQ2xDLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSzs7Ozs7Ozs7Ozs7Ozs7O29CQWVaLEtBQUssQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLFFBQVE7Ozs7O3dCQUsvQixLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxPQUFPOzs7O3dCQUl0QyxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxRQUFROzs7O29CQUkzQyxLQUFLLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxRQUFRO3dCQUMvQixLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxRQUFROzs7O3dCQUl2QyxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxnQkFBZ0I7OztJQUduRSxZQUFZO0NBQ2YsQ0FBQyJ9